/**
 * The ink button. No semantic role of its own — it is used where a control has
 * to outrank a `WhiteButton` without claiming the market accent — so it keeps
 * its literal fill and takes only the shape and motion from `.ce-btn`.
 */
export const BlackButton = ({ text, onClick = () => {}, className = "" }) => {
  return (
    <button type="button" onClick={onClick} className={`ce-btn ce-btn-ink ${className}`.trim()}>
      {text}
    </button>
  );
};
